import {inject, Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {of} from "rxjs/internal/observable/of";

@Injectable({
    providedIn: 'root'
})
export class IsEndOfFreeDemoGuard  {
    private router = inject(Router)

    canActivate(): Observable<boolean> {
        const isEndOfFreeDemo = localStorage.getItem('isEndOfFreeDemo') !== 'true';

        if (isEndOfFreeDemo === false) {
            this.router.navigate(['login']);
        }
        return of(isEndOfFreeDemo);
    }
}